module.exports = __webpack_public_path__ + "static/media/csv-multi-files.16a4c233.svg";